import push from '../../utils/routing';

export default (spaceId) => () => push(`/dashboard/${spaceId}/community/feed`);

export const changeSpaceNav = (spaceId) => () =>
  push(`/dashboard/${spaceId}/myspacenav`);
